import { RecordWithImageFields } from '@akin-home/images';
import { image_thumbnail_edits } from '../data/image_size_edits';

import { makeRecordImageHook, useRecordImage } from './useRecordImage';

interface Params {
  record?: RecordWithImageFields;
  edits?: any;
  config?: any;
}

export const makeRecordThumbnailHook =
  (hook: ReturnType<typeof makeRecordImageHook>) => (params: Params) =>
    hook({ edits: image_thumbnail_edits, ...params });

export const useRecordThumbnail = makeRecordThumbnailHook(useRecordImage);
